export default "__VITE_ASSET__CmhYdcqn__"